import React from 'react';
import PropTypes from 'prop-types';
// import tc from 'tinycolor2';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import CoreMap from '@bd/bdui-coremap';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContentBanner from '../../components/ContentBanner';
import LivingMenu from '../../components/menus/Living';
import PhotoList from '../../components/PhotoList';
import SitePlanLinks from './SitePlanLinks';
import { colors, typography } from '../../styles';

const styles = css`
  .PageSection_wrapper {
    max-width: 100%;
    padding: 20px 0;
    @media (min-width: 768px) {
      padding: 50px 0;
    }
  }
  .SitePlans {
    background-color: ${colors.color4}
  }
  .SitePlan {
    display: block;
    width: 100%;
  }
  .Siteplan_image {
    background-color: #FFFFFF;
    width: 100%;
    padding: 20px;
    box-shadow: 2px 2px 15px 0 rgba(0,0,0,0.04);
  }
  .Location_mapRow {
    display: flex;
  }
  .Location_addressWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    text-align: center;
    width: 100%;
    flex-shrink: 0;
    margin-top: 0;
    padding: 0 40px;
    background-color: ${colors.color1Dark};
    height: 245px;
    @media (min-width: 768px) {
    width: 30%;
    height: 530px;
    }
  }
  .Location_address {
    font-family: ${typography.SansSerif};
    font-size: 16px;
    font-weight: 300;
    display: block;
    color: #FFFFFF;
    @media (min-width: 768px) {
      font-size: 18px;
    }
    span{
      letter-spacing: 1px;
      text-transform: uppercase;
      font-size: 20px;
      @media (min-width: 768px) {
        font-size: 22px;
      }
    }
  }
  .Location_logoWrapper {
    background-color: ${colors.white};
    margin: 15px auto;
    @media(min-width: 768px) {
      width: 180px;
    }
    @media(min-width: 992px) {
      width: 250px
    }
    @media(min-width: 1200px) {
      width: 290px
    }
    @media(min-width: 1400px) {
      width: 300px
    }
  }

`;

const mapStyles = css`
  width: 100%;
  height: 100%;
  @media (min-width: 768px) {
    width: 70%;
    height: 530px;
  }
  .leaflet-popup {
    transition: none;
    background-color: white;
    bottom: 18px !important;
    left: -100px !important;
  }
  .leaflet-container {
    height: 100%;
    width: 100%;
    z-index: 0;
    a.leaflet-popup-close-button {
      font-size: 15px;
      color: ${colors.color1};
      background-color: white;
      padding: 4px;
      width: auto;
      height: auto;
    }
  }
  .leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: 0;
    background: none;
  }
  .leaflet-popup-content-wrapper,
  .leaflet-popup-tip {
    box-shadow: 0px 5px 15px 1px rgba(0,0,0,0.40);
  }
  .leaflet-popup-content {
    margin: 0;
    width: 200px !important;
    background-color: ${colors.white};
  }
  .MapMarker_locationPopUp {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 15px;
  }
  .MapMarker_locationTitle {
    font-weight: 400;
    line-height: 1.5rem;
    font-size: 16px;
    letter-spacing: 0.75px;
    margin: 0;
    color: ${colors.color1Light};
  }
  .leaflet-pane .leaflet-marker-pane img {
    height: 25px !important;
    width: 25px !important;
    margin-left: -12px !important;
    margin-top: -35px !important;
  }
`;


function Vision({ page, builder, widget }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        background={get(page, 'page_image.contentUrl')}
        video={get(page, 'header_video.contentUrl')}
      />
      <LivingMenu />
      <ContentBanner
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
        video={get(welcome, 'video')}
      />
      <div className="PageSection_wrapper">
        <div className="container">
          <div className="">
            {
              get(page, 'site_plan_buttons', []).length > 0 &&
                <SitePlanLinks page={get(page, 'site_plan_buttons')} />
            }
          </div>
        </div>
        <div className="container">
          <h3 className="PageSection_title">{`${get(builder, 'name')} Location`}</h3>
          <div className="Location_mapRow">
            <CoreMap
              className={mapStyles}
              markers={get(widget, 'location_list', []).map(ll => get(ll, 'location[0]'))}
              pin={{
                iconUrl: '/images/map-pin.svg',
                iconSize: [32, 46],
                iconAnchor: [16, 46],
              }}
              popup={({ marker: location }) => (
                <div className="MapMarker_locationPopUp">
                  <h5 className="MapMarker_locationTitle">{location.title}</h5>
                </div>
              )}
              boundaryPadding={0}
            />
            <div className="Location_addressWrapper">
              <address className="Location_address">
                <div className="Location_logoWrapper">
                  <Image
                    className="w-100"
                    src={get(page, 'map_logo.contentUrl')}
                    alt={get(page, 'map_logo.name')}
                    height={800}
                    width={800}
                    preserve
                  />
                </div>
                <span>Laguna Isles</span><br />
                {`${get(builder, 'address.streetAddress')}, `}<br />
                {`${get(builder, 'address.addressLocality')}, ${get(builder, 'address.addressRegion')} `}
                {get(builder, 'address.postalCode')}
              </address>
            </div>
          </div>
        </div>
      </div>
      <div className="PageSection_wrapper">
        <div className="container">
          {
          get(page, 'content_banner') && get(page, 'content_banner').length > 0 &&
           get(page, 'content_banner').map(item => (
             <div key={item._id} className="SectionContentBanner">
               <h3 className="PageSection_title">{item.title}</h3>
               <span className="PageSection_copy" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'copy'))} />
             </div>
           ))
          }
        </div>
        {
          get(page, 'photo_gallery', []).length > 0 &&
          <div className="container">
            <PhotoList photos={get(page, 'photo_gallery', [])} />
          </div>
        }
      </div>
    </PageWrapper>
  );
}

Vision.propTypes = {
  builder: PropTypes.object.isRequired,
  page: PropTypes.object.isRequired,
  widget: PropTypes.object,
};

Vision.defaultProps = {
  widget: undefined,
};

export default withData(
  {
    builder: true,
    page: 'vision',
    widget: 'vision_map_locations',
  },
)(Vision);



// WEBPACK FOOTER //
// ./src/pages/Vision/index.js